import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c6-six-three-two-one',
  templateUrl: './c6-six-three-two-one.component.html',
  styleUrls: ['./c6-six-three-two-one.component.scss']
})
export class C6SixThreeTwoOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
